/* global gdAlertify */
import { useState, useEffect } from "react";
import axiosInstance from "../../config/axiosConfig";
import { formatMoney } from "../../utils/utils";
import BuscarAuxiliar from "./BuscarAuxiliar";
import GdTable from "./GdTable";

const retencionSii = 0.855;

const BoletasHonorarios = () => {
    const [periodo, setPeriodo] = useState(new Date().toISOString().slice(0, 7));
    const [boletas, setBoletas] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [file, setFile] = useState(null);
    const [auxiliarInfo, setAuxiliarInfo] = useState(null);
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [selectedMovement, setSelectedMovement] = useState(null);
    const [observacion, setObservacion] = useState("");
    const [categoria, setCategoria] = useState("");
    const [detalle, setDetalle] = useState("");
    const [periodoModal, setPeriodoModal] = useState("");
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [notaError, setNotaError] = useState("");
    const [estadoModal, setEstadoModal] = useState(""); // 'emitida' o 'error'

    useEffect(() => {
        obtenerBoletas();
    }, [periodo]);

    const obtenerBoletas = async () => {
        try {
            const response = await axiosInstance.post("/financiero/boletas/lista", { periodo });
            setBoletas(response.data.data);
        } catch (error) {
            console.error("Error al obtener las boletas:", error);
        }
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSeleccionAuxiliar = (auxiliar) => {
        setAuxiliarInfo(auxiliar);
    };

    const handleAssignClick = (movement) => {
        setSelectedMovement(movement);
        setObservacion('');
        setCategoria('');
        setDetalle('');
        setPeriodoModal('');
        setAuxiliarInfo(null);
        setShowAssignModal(true);
    };

    const handleUploadFile = async () => {
        if (file) {
            const formData = new FormData();
            formData.append("file", file);
            try {
                await axiosInstance.post("/financiero/boletas/subir", formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                alert("Archivo subido con éxito");
                setShowModal(false);
                obtenerBoletas();
            } catch (error) {
                console.error("Error al subir el archivo:", error);
                alert("Hubo un error al subir el archivo");
            }
        } else {
            alert("Por favor, seleccione un archivo para subir.");
        }
    };

    const handleGuardarEstado = async () => {
        const endpoint = "/financiero/boletas/asignar";

        const payload = {
            auxiliar_id: selectedMovement.auxiliar_id,
            nota: notaError,
            periodo,
            estadoModal
        };

        gdAlertify.confirm({
            title: estadoModal === "emitida" ? "Confirmar Emisión" : "Confirmar Error",
            message: `¿Está seguro de marcar esta boleta como ${estadoModal}?`,
            onConfirm: async () => {
                gdAlertify.showLoader();
                try {
                    const response = await axiosInstance.post(endpoint, payload);

                    if (!response.data.error) {
                        gdAlertify.notiSuccess(`Boleta marcada como ${estadoModal}.`);
                        setShowErrorModal(false);
                        obtenerBoletas();
                    } else {
                        gdAlertify.notiError(response.data.message || "Error al registrar.");
                    }
                } catch (error) {
                    gdAlertify.notiError("No se pudo conectar con el servidor.");
                } finally {
                    gdAlertify.hideLoader();
                }
            },
            onCancel: () => {
                gdAlertify.notify("Acción cancelada", "error");
            },
        });
    };

    const columns = [
        { title: "Rut", name: "rut" },
        { title: "Nombre", name: "nombre_auxiliar", render: row => row.nombre_auxiliar || "" },
        { title: "Apellido Paterno", name: "apepat_auxiliar", render: row => row.apepat_auxiliar || "" },
        { title: "Apellido Materno", name: "apemat_auxiliar", render: row => row.apemat_auxiliar || "" },
        {
            title: "N° turnos",
            name: "cantidad_turnos_adelanto",
            cellClassName: "border-left",
            render: row => `${row.cantidad_turnos_adelanto || 0}`
        },
        {
            title: "Total turnos Bruto",
            name: "turnos_adelanto",
            render: row => `$${formatMoney(row.valor_turnos_adelanto || 0)}`
        },
        {
            title: "Horas Extras Bruto",
            name: "horas_extras_adelanto",
            render: row => `$${formatMoney(row.horas_extras_adelanto || 0)}`
        },
        {
            title: "Valor Boleta",
            name: "valor_boleta",
            render: row => `$${formatMoney((row.valor_turnos_adelanto || 0) + (row.horas_extras_adelanto || 0))}`
        },
        {
            title: "Liquido Boleta",
            name: "liquido_a_145",
            render: row => `$${formatMoney(((row.valor_turnos_adelanto || 0) + (row.horas_extras_adelanto || 0)) * retencionSii)}`
        },
        {
            title: "Tiene Boleta Electrónica",
            name: "datos_sii",
            render: row => row.datos_sii || ""
        },
        {
            title: "Notas Boleta",
            name: "notas_boleta",
            render: row => row.notas_boleta || ""
        },
        {
            title: "Estado",
            name: "estado",
            render: row => {
                const estado = row.boleta_estado;
                const color = estado === 'aprobada' ? 'success' : estado === 'rechazada' ? 'danger' : 'secondary';
                const label = estado === 'aprobada' ? 'Emitida' : estado === 'rechazada' ? 'Error' : 'No Emitida';
                return <span className={`badge bg-${color}`}>{label}</span>;
            }
        },
        {
            title: "Acciones",
            name: "acciones",
            render: row => {
                const estado = row.boleta_estado;

                // Si ya está aprobada o rechazada, no mostramos botones
                if (estado === "aprobada" || estado === "rechazada") {
                    return null;
                }

                // Si está pendiente (u otro estado), mostrar los botones
                return (
                    <>
                        <button
                            className="btn btn-sm btn-success me-1"
                            onClick={() => {
                                setSelectedMovement(row);
                                setNotaError("");
                                setEstadoModal("emitida");
                                setShowErrorModal(true);
                            }}
                        >
                            Confirmar emisión
                        </button>
                        <button
                            className="btn btn-sm btn-danger"
                            onClick={() => {
                                setSelectedMovement(row);
                                setNotaError("");
                                setEstadoModal("error");
                                setShowErrorModal(true);
                            }}
                        >
                            Marcar error
                        </button>
                    </>
                );
            }
        }
    ];

    return (
        <div className="container mt-4">
            <div className="card p-4 shadow">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3>Boletas Emitidas</h3>
                    <div className="d-flex align-items-center">
                        <label className="form-label me-2">Período:</label>
                        <input
                            type="month"
                            className="form-control me-3"
                            value={periodo}
                            onChange={(e) => setPeriodo(e.target.value)}
                        />
                        <button className="btn btn-primary" onClick={obtenerBoletas}>Filtrar</button>
                        <button className="btn btn-secondary ms-3" onClick={() => setShowModal(true)}>
                            Subir archivo
                        </button>
                    </div>
                </div>

                <GdTable
                    columns={columns}
                    data={boletas}
                    stickyHeader={true}
                    height={800}
                    showCsvExport={true}
                    initialSort={[0, "asc"]}
                    itemsPerPageOptions={[100, 200, 300, 500, 1000]}
                    defaultItemsPerPage={500}
                />
            </div>

            {/* Modal para subir archivo */}
            {showModal && (
                <div className="modal fade show" style={{ display: "block" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Subir Archivo</h5>
                                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <input type="file" className="form-control" onChange={handleFileChange} />
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cerrar</button>
                                <button className="btn btn-primary" onClick={handleUploadFile}>Subir</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* Modal único para nota de emisión/error */}
            {showErrorModal && (
                <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{estadoModal === "emitida" ? "Confirmar Emisión" : "Marcar Boleta con Error"}</h5>
                                <button type="button" className="btn-close" onClick={() => setShowErrorModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <label className="form-label">Nota:</label>
                                <input type="text" className="form-control" value={notaError} onChange={(e) => setNotaError(e.target.value)} />
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setShowErrorModal(false)}>Cancelar</button>
                                <button className="btn btn-primary" onClick={handleGuardarEstado}>Guardar</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BoletasHonorarios;
